import { MarkdownBlock } from './MarkdownBlock';
import { MarkdownBuilder } from '../MarkdownBuilder';

export class MarkdownList extends MarkdownBlock {
  protected items: MarkdownBuilder[] = [];

  constructor(protected sorted = false) {
    super();
  }

  /**
   * Cada elemento de la lista es un MarkdownBuilder.
   *
   * Si se pasa text como parámetro, este texto será agregado mediante
   * builder.p(text)
   */
  add(text?: string) {
    const newBuilder = new MarkdownBuilder();

    if (text) newBuilder.p(text);
    this.items.push(newBuilder);

    return newBuilder;
  }

  toString(sorted = this.sorted): string {
    const items = this.items.map((builder) => {
      return builder.toMarkdown().split('\n');
    });

    const tab = sorted ? '    ' : '  ';

    return items
      .map((item, i) => {
        let str = '';
        if (sorted) str += `${i + 1}) `;
        else str += '- ';

        item.forEach((itemPart, j) => {
          if (itemPart.match(/^ *$/)) {
            str += '\n';
            return;
          }

          str += j === 0 ? '' : tab;
          str += itemPart;
          str += '\n';
        });

        return str;
      })
      .join('\n');
  }
}
